import { h, Component } from 'preact';
import { translate } from 'react-i18next';

import LinkServiceCard from '../LinkServiceCard.js';

// const baseSettings = {
// 	base: 'http://localhost:3006',
// 	redirect: 'http://localhost:8080/linked-accounts'
// }

const baseSettings = {
	base: 'https://api.hirezstudios.com',
	redirect: 'https://my.hirezstudios.com'
};

function getURLParam(name, url) {
	if (!url) url = location.href;
	name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
	let regexS = '[\\?&]'+name+'=([^&#]*)';
	let regex = new RegExp( regexS );
	let results = regex.exec( url );
	return results == null ? null : results[1];
}

let redirect_uri = getURLParam('redirect_uri');

const services = [
	{
		portal_name: 'Epic',
		display_name: 'Epic Games',
		oauth_url: `${baseSettings.base}/oauth/out/epic?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: ''
	},
	{
		portal_name: 'discord',
		display_name: 'Discord',
		oauth_url: `${baseSettings.base}/oauth/out/discord?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: 'Realm Royale'
	},
	{
		portal_name: 'Nintendo',
		display_name: 'Nintendo',
		oauth_url: `${baseSettings.base}/oauth/out/nintendo?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: 'Smite & Paladins'
	},
	{
		portal_name: 'Steam',
		display_name: 'Steam',
		oauth_url: `${baseSettings.base}/oauth/out/steam?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: ''
	},
	{
		portal_name: 'ps4',
		display_name: 'Playstation',
		oauth_url: `${baseSettings.base}/oauth/out/playstation?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: 'Smite & Paladins'
	},
	{
		portal_name: 'xbox',
		display_name: 'Xbox',
		oauth_url: `${baseSettings.base}/oauth/out/xbox?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: 'Smite & Paladins'
	},
	{
		portal_name: 'Twitch',
		display_name: 'Twitch',
		oauth_url: !redirect_uri ? `${baseSettings.base}/oauth/out/twitch?action=link&url=${baseSettings.redirect}/linked-accounts` : `${baseSettings.base}/oauth/out/twitch?action=link&redirect_uri=${redirect_uri}&url=${baseSettings.redirect}/linked-accounts`,
		rewards: 'Smite & Paladins'
	},
	{
		portal_name: 'Amazon',
		display_name: 'Amazon',
		oauth_url: !redirect_uri ? `${baseSettings.base}/oauth/out/amazon?action=link&url=${baseSettings.redirect}/linked-accounts` : `${baseSettings.base}/oauth/out/amazon?action=link&redirect_uri=${redirect_uri}&url=${baseSettings.redirect}/linked-accounts`,
		rewards: '',
		rewardsString: false
	},
	{
		portal_name: 'Facebook',
		display_name: 'Facebook',
		oauth_url: `${baseSettings.base}/oauth/out/facebook?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: ' '
	},
	{
		portal_name: 'Google',
		display_name: 'Google',
		oauth_url: `${baseSettings.base}/oauth/out/google?action=link&url=${baseSettings.redirect}/linked-accounts`,
		rewards: ' '
	}
];

class LinkedAccounts extends Component {

  disconnectService = (portal) => {
		this.setState( { activePortal: portal } );
  	fetch(`${baseSettings.base}/acct/unlink`, {
  		method: 'post',
  		headers: {
  			'Content-Type': 'application/json'
  		},
  		body: `{"webToken": "${this.props.userData.webToken}", "platform": "${portal}"}`
  	}).then((response) => response.json()).then((response) => {
  		// force recheck?
			if (response.statusCode && response.statusCode === 501) {
				this.setState( { showWarningMessage: true } );
			}
			else if (response.statusCode && response.statusCode === 400) {
				this.setState( { showWarningMessage: true } );
			}
			else {
				window.location.reload();
			}
  	});
	}
	
	forceDisconnect = (portal) => {
		fetch(`${baseSettings.base}/acct/unlink`, {
  		method: 'post',
  		headers: {
  			'Content-Type': 'application/json'
  		},
  		body: `{"webToken": "${this.props.userData.webToken}", "platform": "${portal}", "ignoreMergeChecking": "y"}`
  	}).then((response) => response.json()).then((response) => {
			window.location.reload();
  	});
	}

	populateAccountInfo = (response) => {
		let states = {};
		response.linkedPortalAccounts.concat(response.linkedCredentials).forEach((account) => {
			states[account.portal] =  {
				username: account.portalUsername,
				linked: account.linked
			};
			if (account.portal === 'Amazon' && account.linked === true && this.getURLParam('redirectUrl')) {
				window.location.href = decodeURIComponent(this.getURLParam('redirectUrl'));
			}
		});
		this.setState({ accountLinkStates: states });
	}

	checkErrors = () => {
		if (this.getURLParam('error')) {
			this.setState({error: this.getURLParam('error').replace(/\+/g, " ")});
		}
	}

	checkRedirectSuccess = () => {
		if (this.getURLParam('redirect_uri_complete')) {
			location.href = getURLParam('redirect_uri_complete');
		}
	}

	getURLParam = ( name, url ) => {
		if (!url) url = location.href;
		name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
		let regexS = '[\\?&]'+name+'=([^&#]*)';
		let regex = new RegExp( regexS );
		let results = regex.exec( url );
		return results == null ? null : results[1];
	}

	constructor(props) {
		super(props);
		this.state = {
			accountLinkStates: null,
			error: null,
			showWarningMessage: false,
			agreedToWarning: false,
			activePortal: undefined,
			showAltView: null,
			amazon: false,
			redirectUrl: null
		};
	}
	
	componentDidMount() {
		window.scrollTo(0,0);
		this.checkErrors();
		this.checkRedirectSuccess();

		if (this.getURLParam('redirectUrl')) {
			localStorage.setItem('linkRedirectUrl', this.getURLParam('redirectUrl'));
			this.setState({ redirectUrl: this.getURLParam('redirectUrl') });
		}
		if (this.getURLParam('linked') === 'amazon') {
			window.location.href = decodeURIComponent(localStorage.getItem('linkRedirectUrl'));
		}

		if (redirect_uri) {
			this.setState({showAltView: 'twitch'});
		}

		if (this.context.userData.accountInfo !== null) {
			this.populateAccountInfo(this.context.userData.accountInfo);
		}
		
		// if (this.getURLParam('amazon')) {
		// 	this.setState({
		// 		amazon: true
		// 	})
		// }
	}

	componentDidUpdate(nextProps) {
		if (this.props !== nextProps && this.context.userData.accountInfo !== null && this.state.accountLinkStates === null) {
			this.populateAccountInfo(this.context.userData.accountInfo);
			if (this.getURLParam('linked') === 'amazon') {
				window.location.href = decodeURIComponent(localStorage.getItem('linkRedirectUrl'));
			}
		}
	}

	render() {
		const { t } = this.props;
  	return (
  		<div className={'v-linked-accounts ' + (this.state.showAltView !== null ? 'show-alt-view ' + this.state.showAltView : '') + (this.state.redirectUrl !== null ? 'amazon-first' : '')}>
  			<h1>{t('Linked & Connected Accounts')}</h1>
  			<p>{t('Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.')}</p>
  			{this.state.error &&
  			<p className="account-error">{this.state.error}</p>
				}
				{this.state.showAltView === 'twitch' && 
				<div className="alt-view twitch">
					<div>
						<img src="https://webcdn.hirezstudios.com/account-services/linked-services/twitch-logo.png" />
					</div>
					<p dangerouslySetInnerHTML={{__html: t('Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target="_blank" href="https://twitch.amazon.com/prime/loot/smite?ctx=account-link" >here</a> to return now.')}} />
					<p dangerouslySetInnerHTML={{__html: t('You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target="_blank" href="https://twitch.amazon.com/prime/loot/smite?ctx=account-link">here</a>, and link your Hi-Rez account to your platform of choice <a target="_blank" href="https://my.hirezstudios.com/linked-accounts" >here</a>.')}} />
				</div>
				}
				{this.state.showWarningMessage &&
					<div className="unlink-error-container">
						<div className="close" onClick={() => this.setState({showWarningMessage: false})}>X</div>
						<div className="header">
							<i className="icon-logout" />
							<h6 dangerouslySetInnerHTML={{__html: t(`To unlink your account, please submit a request to Customer Support <a href="https://www.hirezstudios.com/submit-support-ticket" target="_blank" >here</a>.`)}} />
						</div>
					</div>
				}
				<div className={`links-wrapper`}>
					{ this.state.accountLinkStates != null && services.map((service) =>
						(<LinkServiceCard
							name={service['display_name']}
							image={`https://webcdn.hirezstudios.com/account-services/linked-services/${service['display_name'].toLowerCase().replace(/\s/g, "-")}-icon.png`}
							username={this.state.accountLinkStates[service['portal_name']] && this.state.accountLinkStates[service['portal_name']].username  || ''}
							linked={this.state.accountLinkStates[service['portal_name']] && this.state.accountLinkStates[service['portal_name']].linked || false}
							url={service['oauth_url']}
							portal={service['portal_name']}
							rewardsString={service.rewards}
							disconnectCallback={this.disconnectService}
	  				/>)
					)}
				</div>
  		</div>
  	);
	}
}

export default translate(['common'], { withRef: true })(LinkedAccounts);



// WEBPACK FOOTER //
// ./components/views/LinkedAccounts.js